import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { routingNameByRole } from "@/router/auth-guard";
import CardWrap from "@/components/common/CardWrap.vue";
import Btn from "@/components/common/Btn.vue";
import Input from "@/components/common/form/Input.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'new',
  setup(__props) {

const store = useStore();
const router = useRouter();

const email = ref("");
const password = ref("");

const onSubmit = async () => {
  await store
    .dispatch("signin", {
      email: email.value,
      password: password.value,
    })
    .then((result) => {
      if (result) {
        router.replace({ name: routingNameByRole(store.state.role) });
      }
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CardWrap, { class: "signin-card" }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createVNode(Input, {
          type: "email",
          id: "email",
          modelValue: email.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
          placeholder: "メールアドレス",
          class: "email-input"
        }, null, 8, ["modelValue"]),
        _createVNode(Input, {
          type: "password",
          id: "password",
          modelValue: password.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
          placeholder: "パスワード",
          class: "password-input"
        }, null, 8, ["modelValue"]),
        _createVNode(Btn, {
          class: "full-width",
          "on-click-event": onSubmit
        }, {
          default: _withCtx(() => [
            _createTextVNode("ログイン")
          ]),
          _: 1
        })
      ], 32)
    ]),
    _: 1
  }))
}
}

})